var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPaginacaoUltima01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    className: "st0",
    width: 35.8,
    height: 35.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "go_to_last_page",
    d: "M29.8,1.1h5.7v33.9h-5.7V1.1L29.8,1.1z M4.4,1.1L4.4,1.1L21.4,18L4.4,34.9l-4-4l13-13L0.5,5L4.4,1.1 L4.4,1.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPaginacaoUltima01);
export default __webpack_public_path__ + "static/media/ico-paginacao-ultima-01.66217a0fd12361e4aacb2e181257592c.svg";
export { ForwardRef as ReactComponent };